import { addDoc, getDocs, deleteDoc, collection, query, where, doc } from "firebase/firestore";
import { Post as IPost } from "../home/Home";
import { auth, db } from "../../config/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AppContext } from "../../App";
import { Comment as IComment } from "./Comments";
import "./Comments.css";

interface Props {
  comment: IComment;
  getComments?: () => void;
}

interface CommentLike {
  userId: string;
  commentLikeId: string;
  commentId: string;
}

export const Comment = (props: Props) => {
  const { comment, getComments } = props;
  const [user, loading, error] = useAuthState(auth);
  const [likes, setLikes] = useState<CommentLike[] | null>(null);
  const [authWarningVisible, setAuthWarningVisible] = useState<boolean>(false);
  const navigate = useNavigate();
  const [showConfirmDelete, setShowConfirmDelete] = useState<boolean>(false);

  const { setSelectedUsername } = useContext(AppContext);
  const { setSelectedUserId } = useContext(AppContext);

  const likesRef = collection(db, "comment-likes");

  const addLike = async () => {
    try {
      if (user) {
        const newDoc = await addDoc(likesRef, { userId: user?.uid, commentId: comment.id });
        setLikes(prev =>
          prev
            ? [...prev, { userId: user?.uid, commentId: comment.id, commentLikeId: newDoc.id }]
            : [{ userId: user?.uid, commentId: comment.id, commentLikeId: newDoc.id }]
        );
      } else {
        setAuthWarningVisible(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const removeLike = async () => {
    try {
      if (user) {
        const likesToDeleteQuery = query(likesRef, where("commentId", "==", comment.id), where("userId", "==", user?.uid));
        const likeToDeleteData = await getDocs(likesToDeleteQuery);
        const likeId = likeToDeleteData.docs[0].id;
        const likeToDelete = doc(db, "post-likes", likeId);
        await deleteDoc(likeToDelete);
        setLikes(prev => prev && prev.filter(like => like.commentLikeId !== likeId));
      } else {
        setAuthWarningVisible(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteComment = async () => {
    try {
      setShowConfirmDelete(false);
      if (user?.uid != comment.userId) return;
      const commentToDelete = doc(db, "comments", comment.id);
      await deleteDoc(commentToDelete);
      getComments && getComments();
    } catch (error) {
      console.log(error);
    }
  };

  // const editComment = async () => {
  //   setSelectedCommentId(comment.id);
  //   navigate("/editcomment");
  // };

  const userHasLikedPost = likes?.find(like => like.userId === user?.uid);

  const likesDoc = query(likesRef, where("commentId", "==", comment.id));

  const getLikes = async () => {
    const data = await getDocs(likesDoc);
    setLikes(data.docs.map(doc => ({ userId: doc.data().userId, commentId: comment.id, commentLikeId: doc.id })));
  };
  const goToUsersPosts = () => {
    if (user?.uid === comment.userId) {
      navigate("/myposts");
      return;
    }
    setSelectedUsername(comment.username);
    setSelectedUserId(comment.userId);
    navigate("/userpage");
  };

  useEffect(() => {
    getLikes();
  }, []);

  return (
    <>
      <div className='card w-100 mt-2'>
        {user?.uid === comment.userId && (
          <div className='editButtons'>
            {/* <button className='btn btn-primary mx-2 p-1 opacity-75' onClick={editComment}>
              Edit
            </button> */}
            {showConfirmDelete ? (
              <>
                <button className='btn btn-danger mx-2 p-1 opacity-75' onClick={deleteComment}>
                  Confirm Delete
                </button>
                <button className='btn btn-success p-1 opacity-75' onClick={() => setShowConfirmDelete(false)}>
                  Cancel
                </button>
              </>
            ) : (
              <button className='btn btn-danger mx-2 p-1 opacity-75' onClick={() => setShowConfirmDelete(true)}>
                Delete
              </button>
            )}
          </div>
        )}
        <div className='card-body p-1 m-0'>
          <div className='card-title d-flex justify-content-start p-0 m-0 align-items-baseline'>
            <div>
              <button
                onClick={user ? (userHasLikedPost ? removeLike : addLike) : () => setAuthWarningVisible(true)}
                className='btn btn-outline-warning mx-1 p-0'>
                {userHasLikedPost ? <>&#128078;</> : <>&#128077;</>}
              </button>
              <small>
                {likes?.length && likes?.length > 0 ? likes?.length : 0} {likes?.length === 1 ? "Like" : "Likes"}
              </small>
            </div>
            <button className='btn'>
              <small className='mx-1 fw-bolder' onClick={goToUsersPosts}>
                @{comment.username}:
              </small>
            </button>
          </div>
          <div className='card-text mx-2 p-0 d-flex justify-content-start'>
            <p className=' m-0 pb-2 text-start'>{comment.text}</p>
          </div>
        </div>

        {/* <button
        onClick={user ? (userHasLikedPost ? removeLike : addLike) : () => setAuthWarningVisible(true)}
        className='btn btn-outline-warning mx-2 p-1'>
        {userHasLikedPost ? <>&#128078;</> : <>&#128077;</>}
      </button> */}
        {/* <small>
        {likes?.length && likes?.length > 0 ? likes?.length : 0} {likes?.length === 1 ? "Like" : "Likes"}
      </small> */}
        {/* <button className='btn'>
        <small className='mx-2 fw-bolder' onClick={goToUsersPosts}>
          @{comment.username}
					</small>
				</button> */}
      </div>
      {authWarningVisible && (
        <div className='alert alert-danger w-100 mt-1 mx-auto py-2 fw-bolder d-flex justify-content-between align-items-center'>
          <span>Please log in to interact with comments</span>
          <button className='btn btn-close ms-2 p-0' onClick={() => setAuthWarningVisible(false)}></button>
        </div>
      )}
    </>
  );
};
